// Static demo-mode data for PlanBillingTab.component.jsx.
// This demo build never has a real Razorpay-backed subscription in Redux,
// so the tab would otherwise show "No Active plan" / no payment details.
//
// `nextPaymentDate`/`subscriptionEndDate` mirror the shapes the real
// subscription doc uses (a `{ seconds }` epoch and a Firestore-Timestamp-like
// object exposing `.toDate()`, respectively — see CancelSubscriptionModal
// for the same `.toDate()` shape).
import { plansKeys, plans } from '@/config/constants';

export const DEMO_PLAN_ID = Object.keys(plans).find(
  (id) => plans[id].key === plansKeys.grow && plans[id].billingCycle === 'month'
);

// Anchored to "now" (18 days out, mid-way through a monthly cycle) so the
// subscription never looks lapsed no matter when the demo is opened.
const DEMO_CYCLE_END_DATE = new Date(Date.now() + 18 * 24 * 60 * 60 * 1000);

export const DEMO_SUBSCRIPTION = {
  planId: DEMO_PLAN_ID,
  status: 'active',
  subscriptionId: 'sub_demo_0001',
  nextPaymentDate: {
    seconds: Math.floor(DEMO_CYCLE_END_DATE.getTime() / 1000),
  },
  subscriptionEndDate: { toDate: () => DEMO_CYCLE_END_DATE },
};

export const DEMO_PAYMENT_DETAILS = {
  email: 'ryan.mitchell@meridianlabs.com',
  card: { last4: '4242' },
};
